var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action, observe, computed } from "../ExternalDependencies";
export class Parser {
    constructor(retreiver) {
        this.settings = {
            interval: -1
        };
        this.wageringInformation = {
            sportsbookNetWon: 0,
            sportsbookTurnover: 0,
            casinoNetWon: 0,
            casinoTurnover: 0,
            sessionStart: new Date()
        };
        this.retriever = retreiver;
    }
    activate() {
        this.userInfoObserverDisposer = observe(this.retriever, "userInfo", change => this.setUserInfo(change.newValue));
        this.retriever.activate();
    }
    deactivate() {
        this.retriever.deactivate();
        this.userInfoObserverDisposer && this.userInfoObserverDisposer();
    }
    getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const settings = yield this.retriever.getSettings();
            this.settings.interval = settings.intervalInMinutes;
        });
    }
    saveSettings(interval) {
        return __awaiter(this, void 0, void 0, function* () {
            const settings = {
                intervalInMinutes: interval
            };
            return this.retriever.saveSettings(settings);
        });
    }
    getWageringInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            const wageringInformation = yield this.retriever.getWageringInformation();
            this.wageringInformation.sportsbookNetWon = wageringInformation.sportsbookNetWon;
            this.wageringInformation.sportsbookTurnover = wageringInformation.sportsbookTurnover;
            this.wageringInformation.casinoNetWon = wageringInformation.casinoNetWon;
            this.wageringInformation.casinoTurnover = wageringInformation.casinoTurnover;
            this.wageringInformation.sessionStart = new Date(wageringInformation.sessions[0].startTimestamp);
        });
    }
    getShowState() {
        return this.retriever.getShowState();
    }
    saveShowState(showState) {
        this.retriever.saveShowState(showState);
    }
    removeShowState() {
        this.retriever.removeShowState();
    }
    setUserInfo(newValue) {
        this.updateUserInfo(newValue);
    }
    updateUserInfo(userInfo) {
        if (userInfo) {
            this.user = {
                isFirstLogin: userInfo.IsFirstLogin,
                currencyCode: userInfo.ISOCurrencyCode
            };
        }
        else {
            this.user = undefined;
        }
    }
    onShow() {
        this.retriever.onShow();
    }
    onClose() {
        this.retriever.onClose();
    }
    get isShowEnabled() {
        return this.retriever.isShowEnabled;
    }
    ;
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "settings", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "wageringInformation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "user", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Parser.prototype, "getSettings", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Parser.prototype, "getWageringInformation", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "setUserInfo", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateUserInfo", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Parser.prototype, "isShowEnabled", null);
//# sourceMappingURL=Parser.js.map